import React from 'react';
import {useEffect} from "react";

export default function InputChoice({label, value, choices, multiple = false, onChange, required = false, emptyLabel = Drupal.tt('- Seleziona -')}) {

  if(multiple) {
    return <InputChoiceMultiple label={label} value={value} choices={choices} onChange={onChange} required={required} />
  }


  const options = []
  if(!required) {
    options.push({name: emptyLabel, value: ''})
  }
  options.push(...choices)

  return <select value={value} onChange={evt => onChange(evt.target.value ?? null)}>
    {options.map(option => <option key={option.value} value={option.value}>{option.name}</option>)}
  </select>
}


function InputChoiceMultiple({label, value, choices, onChange, required = false}) {
  const [open, setOpen] = React.useState(false)
  const numSelected = value.length

  function toggleOpen() {
    setOpen(prev => !prev)
  }

  function handleChoiceSelect(choiceId, selected) {
    if(selected) {
      onChange([...value, choiceId])
    }
    else {
      onChange(value.filter(id => id !== choiceId))
    }
  }

  return <div className={'input-choice-multiple ' + (open ? 'open ' : '') + (numSelected>0 ? 'active' : '')}>
    <div className='label' onClick={toggleOpen}>{label} {numSelected>0 && <span className='numSelected'>({numSelected})</span>} </div>
    <div className='choices' style={{display: open ? 'block' : 'none'}}>
      {choices.map(choice => <InputChoiceMultipleItem key={choice.value} label={choice.name} onChange={selected => handleChoiceSelect(choice.value, selected)} selected={value.includes(choice.value)} />)}
    </div>
  </div>
}

function InputChoiceMultipleItem({label, selected, onChange}) {
  return <div className={'input-choice-multiple-item ' + (selected ? 'selected' : '')} onClick={() => onChange(!selected)}>
    {label}
  </div>
}
